import { Link } from 'react-router-dom-v5-compat';

import {
  CheckMetadata,
  CheckMetadataItemType,
  GroupedCheckMetadataItem,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import AsyncImage from 'dashboard/components-lib/AsyncImage';
import { SelfieSimilarBackgroundDetection } from 'dashboard/models/check';

export const computeSelfieSimilarBackgroundDetectionMetadata = (
  check: SelfieSimilarBackgroundDetection,
): CheckMetadata => {
  const results = check.metadata?.['selfie-embedding-search-results'] ?? [];

  // Generate match details for each matched Selfie
  const metadata = results.map((result, index) => {
    return {
      type: CheckMetadataItemType.Group,
      heading: { title: `Matched Selfie ${index + 1}` },
      items: [
        result['selfie-front-photo-url'] && {
          type: CheckMetadataItemType.Simple,
          label: 'Selfie Photo',
          value: (
            <AsyncImage imageUrl={result['selfie-front-photo-url']} width='400px' height='250px' />
          ),
        },
        result['inquiry-id'] && {
          type: CheckMetadataItemType.Simple,
          label: 'Inquiry',
          value: (
            <Link to={`/dashboard/inquiries/${result['inquiry-id']}`}>{result['inquiry-id']}</Link>
          ),
        },
        !result['inquiry-id'] &&
          result['verification-id'] && {
            type: CheckMetadataItemType.Simple,
            label: 'Verification',
            value: (
              <Link to={`/dashboard/verifications/${result['verification-id']}`}>
                {result['verification-id']}
              </Link>
            ),
          },
        !result['inquiry-id'] &&
          !result['verification-id'] &&
          result['selfie-id'] && {
            type: CheckMetadataItemType.Simple,
            label: 'Selfie',
            value: result['selfie-id'],
          },
      ].filter(Boolean),
    };
  }) as GroupedCheckMetadataItem[];

  return {
    metadata: metadata,
    hideIfVerificationPassed: results.length === 0,
  };
};
